import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  Container,
  Col,
  Row,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  FaEye,
  FaEdit,
  FaTrash,
  FaSyncAlt,
  FaArrowAltCircleRight,
  FaArrowAltCircleLeft,
  FaArrowLeft,
} from 'react-icons/fa'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditClassModal from './EditClassModal'
import { FaChalkboard } from 'react-icons/fa'
import Cookies from 'js-cookie'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'

const DataTable = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  const navigate = useNavigate()
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedClass, setSelectedClass] = useState(null)
  const [allClasses, setAllClasses] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    class: '',
  })
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const userLogged = Cookies.get('user')
    console.log('userLogged', userLogged)
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        setUserRole(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user') // ✅ Remove invalid cookie
      }
    }
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const initialData = []

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [showModal, setShowModal] = useState(false)
  const [courses, setCourses] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      setCourses(res.data.data)
      setAllCourses(res.data.data)
    })
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllClasses()
      .then((response) => {
        console.log('Classes response: ', response.data.data)
        setData(response.data.data)
        setAllClasses(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  const [allCourses, setAllCourses] = useState([])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setSelectedFilters((prev) => ({ ...prev, course: courseId }))
    handleSelect({ course: courseId })
    console.log('HANDLESELECT:', handleSelect)
  }

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((response) => {
        console.log(response.data)
        // setData(response.data.data) // Current view (filtered/unfiltered)
        setAllCourses(response.data.data) // Full master list
        setCourses(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])
  const [newClass, setNewClass] = useState({
    class_name: '',
    course_id: '',
    start_date: '',
    end_date: '',
  })

  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  const [selectedData, setSelectedData] = useState({})

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)
    console.log('SETSELECTEDDATA:', selectedValues)
    fetchFilteredData(selectedValues)
  }

  const fetchFilteredData = (selectedValues) => {
    const { course } = selectedValues
    let updatedData = allClasses // <- this should be classes, not courses
    console.log('updatedData', updatedData)
    if (course) {
      updatedData = updatedData.filter(
        (item) => item.course_id?.toString() === course.toString(),
      )
    }

    setData(updatedData)
  }

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [])
  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewClass((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const instituteId = Cookies.get('institute_id')
      console.log('INSITTUTE ID:', instituteId)
      console.log('Sending data: ', newClass)
      const payload = {
        ...newClass,
        institute_id: instituteId,
      }
      console.log('PAYLOAD:', payload)
      const response = await ApiEndpoints.addClass(payload)
      setNewClass('Response: ', response)
      // setData(response.data.data)
      // Reset the form after submission
      setNewClass({
        class_name: '',
        course_id: '',
        start_date: '',
        end_date: '',
      })

      setShowModal(false)
      toast.success(response.data.result)
    } catch (error) {
      toast.error(error.response?.data?.result)
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleRefresh = async () => {
    try {
      const response = await ApiEndpoints.getAllClasses()
      const allClassData = response.data.data
      setData(allClassData)
      setAllClasses(allClassData) // Optional but ensures allClasses stays in sync

      setSelectedData({})
      setSelectedFilters({ class: '', course: '' })
      setSearch('')
      setCurrentPage(1)
      console.success('Data refreshed successfully')
    } catch (error) {
      console.error('Failed to refresh data.')
    }
  }

  const location = useLocation()
  const handleBackToAddStudent = () => {
    navigate('/AddStudent', {
      state: {
        newStudent: location.state?.newStudent || {},
        studentImage: location.state?.studentImage || null,
        selectedNewCourse: location.state?.selectedNewCourse || null,
      },
    })
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Classes</h2>
         {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
            <Button
              variant="light"
              className="fw-bold"
              onClick={() => setShowModal(true)}
            >
              <FaChalkboard size={18} className="me-2" />
              Add New Class
            </Button>
          )}
        </div>
      </div>
      {/* <Row className="g-2 align-items-end d-flex mt-3 flex-nowrap"> */}
      <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Course</Form.Label>
            {/* <Form.Select
              value={selectedFilters.course}
              onChange={handleCourseChange}
            >
              <option value="">Select Course</option>
              {allCourses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select> */}
            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseChange({ target: { value: course.id } })
                } else {
                  handleCourseChange({ target: { value: '' } })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={courses.filter(
                (cs) => cs.id === Number(selectedFilters.course),
              )}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-0 text-start">
            <Form.Label className="fw-bold d-md-none text-start">
              Search
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Search Class Name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col className="d-flex justify-content-md-end justify-content-start">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>
      {/* <Row className="g-2 mt-3 flex-nowrap d-flex align-items-end">
        <Col md="auto">
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Course</Form.Label>
            <Form.Select
              value={selectedFilters.course}
              onChange={handleCourseChange}
              style={{ minWidth: "200px" }}
            >
              <option value="">Select Course</option>
              {allCourses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md="auto">
          <Form.Group className="mb-0">
            <Form.Control
              type="text"
              placeholder="Search Class Name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ minWidth: "450px" }}
            />
          </Form.Group>
        </Col>

        <Col className="d-flex justify-content-end">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row> */}

      {/* Floating button (mobile only) */}
      <div className="d-md-none">
        <Button
          onClick={handleRefresh}
          title="Refresh"
          variant="primary"
          className="position-fixed bottom-0 end-0 m-3 rounded-circle shadow"
          style={{ width: '60px', height: '60px', zIndex: 999 }}
        >
          <FaSyncAlt size={24} />
        </Button>
      </div>

      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 mt-4 gap-2">
        {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
          <div>
            <Button className="btn-sm btn-md" onClick={handleBackToAddStudent}>
              <FaArrowLeft className="me-1" /> Go Back to Student List
            </Button>
          </div>
        )}
        <div className="d-flex align-items-center ms-auto gap-2 gap-md-3 flex-wrap">
          <p className="text-black m-0">Total Class: {filteredData.length}</p>

          <Form.Select
            className="w-auto"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value))
              setCurrentPage(1)
            }}
          >
            <option value="100">100 per page</option>
            <option value="200">200 per page</option>
            <option value="300">300 per page</option>
          </Form.Select>
        </div>
      </div>

      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr>
            <Th>Class Name</Th>
            {/* <th>Teacher</th> */}
            <Th>Course Name</Th>
            <Th>Start Date</Th>
            <Th>End Date</Th>
            <Th>Number of Students</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <Tr key={index} className="align-middle">
                <Td>{item.class_name}</Td>
                <Td>
                  {' '}
                  {courses.find((course) => course.id === item.course_id)
                    ?.name || 'N/A'}
                </Td>
                <Td>
                  {item?.start_date
                    ? new Date(item.start_date).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })
                    : 'N/A'}
                </Td>
                <Td>
                  {item?.end_date
                    ? new Date(item.end_date).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })
                    : 'N/A'}
                </Td>
                <Td>{item.student_count || 0}</Td>

                {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                  <Td className="text-center">
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                      <Button
                        variant="warning"
                        onClick={() => {
                          setSelectedClass(item)
                          setShowEditModal(true)
                        }}
                      >
                        <FaEdit />
                      </Button>

                      {/* Delete Button */}
                    </div>
                  </Td>
                )}
              </Tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center text-muted fw-bold p-4">
                No records found
              </td>
            </tr>
          )}
        </Tbody>
      </Table>

      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New Class Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Class</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3">
              <Form.Label>Course *</Form.Label>
              <Form.Select
                name="course_id"
                value={newClass.course_id}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {/* Class Name Field */}
            <Form.Group className="mb-3">
              <Form.Label className="">Class Name *</Form.Label>
              <Form.Control
                type="text"
                name="class_name"
                value={newClass.class_name}
                onChange={handleInputChange}
                placeholder="Enter Class Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="">Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                value={newClass.start_date}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="">End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                value={newClass.end_date}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                className="text-danger"
                type="checkbox"
                id="acknowledgeCheckbox"
                label="I acknowledge and agree that this process is irreversible and cannot be undone."
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
              />
            </Form.Group>
            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button
                variant="success"
                type="submit"
                disabled={!isAcknowledged}
              >
                Save Class
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditClassModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        classData={selectedClass}
      />
    </div>
  )
}

export default DataTable
